/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Certification,
  CertificationRequest,
  CertificationsListParams,
  PaginatedCertificationList,
  PatchedCertificationRequest
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCertificationsListUrl = (params?: CertificationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/certifications/?${stringifiedParams}` : `/api/certifications/`
}

/**
 * Global Certification catalog.
 *
 * Three callers share this endpoint:
 *
 *   - ``is_gigpro_admin`` (taxonomy management) — sees every row including
 *     ``is_active=False`` so admin tools can toggle status.
 *   - location managers — same all-rows view via the CORE-5237 lumping
 *     rule below. The location cert-requirements picker UX historically
 *     called this endpoint; on v4 it moves to the dedicated nested
 *     resource ``/api/locations/{location_id}/available-certifications/``
 *     (``LocationAvailableCertificationsView``), and the v4 permission
 *     cleanup that removes LM access from this catalog will land then.
 *   - pros (read-only browse) — see active-only rows via the default
 *     ``Certification.objects`` manager. The Pro market-aware catalog cut
 *     lives on a dedicated endpoint
 *     ``/api/gigster-profiles/{pk}/available-certifications/``
 *     (``ProAvailableCertificationsView``); this catalog endpoint stays
 *     unfiltered to preserve the byte-identical default contract for
 *     existing clients.
 */
export const certificationsList = async (params?: CertificationsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedCertificationList> => {

  return customFetch<PaginatedCertificationList>(getCertificationsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCertificationsListInfiniteQueryKey = (params?: CertificationsListParams,) => {
    return [
    'infinite', `/api/certifications/`, ...(params ? [params] : [])
    ] as const;
    }

export const getCertificationsListQueryKey = (params?: CertificationsListParams,) => {
    return [
    `/api/certifications/`, ...(params ? [params] : [])
    ] as const;
    }


export const getCertificationsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof certificationsList>>, CertificationsListParams['page']>, TError = void>(params?: CertificationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof certificationsList>>, TError, TData, QueryKey, CertificationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCertificationsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof certificationsList>>, QueryKey, CertificationsListParams['page']> = ({ signal, pageParam }) => certificationsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof certificationsList>>, TError, TData, QueryKey, CertificationsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CertificationsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof certificationsList>>>
export type CertificationsListInfiniteQueryError = void


export function useCertificationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof certificationsList>>, CertificationsListParams['page']>, TError = void>(
 params: undefined |  CertificationsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof certificationsList>>, TError, TData, QueryKey, CertificationsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof certificationsList>>,
          TError,
          Awaited<ReturnType<typeof certificationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCertificationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof certificationsList>>, CertificationsListParams['page']>, TError = void>(
 params?: CertificationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof certificationsList>>, TError, TData, QueryKey, CertificationsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof certificationsList>>,
          TError,
          Awaited<ReturnType<typeof certificationsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCertificationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof certificationsList>>, CertificationsListParams['page']>, TError = void>(
 params?: CertificationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof certificationsList>>, TError, TData, QueryKey, CertificationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCertificationsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof certificationsList>>, CertificationsListParams['page']>, TError = void>(
 params?: CertificationsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof certificationsList>>, TError, TData, QueryKey, CertificationsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCertificationsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCertificationsListQueryOptions = <TData = Awaited<ReturnType<typeof certificationsList>>, TError = void>(params?: CertificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCertificationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof certificationsList>>> = ({ signal }) => certificationsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof certificationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CertificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof certificationsList>>>
export type CertificationsListQueryError = void


export function useCertificationsList<TData = Awaited<ReturnType<typeof certificationsList>>, TError = void>(
 params: undefined |  CertificationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof certificationsList>>,
          TError,
          Awaited<ReturnType<typeof certificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCertificationsList<TData = Awaited<ReturnType<typeof certificationsList>>, TError = void>(
 params?: CertificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof certificationsList>>,
          TError,
          Awaited<ReturnType<typeof certificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCertificationsList<TData = Awaited<ReturnType<typeof certificationsList>>, TError = void>(
 params?: CertificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCertificationsList<TData = Awaited<ReturnType<typeof certificationsList>>, TError = void>(
 params?: CertificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCertificationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCertificationsCreateUrl = () => {




  return `/api/certifications/`
}

/**
 * Global Certification catalog.
 *
 * Three callers share this endpoint:
 *
 *   - ``is_gigpro_admin`` (taxonomy management) — sees every row including
 *     ``is_active=False`` so admin tools can toggle status.
 *   - location managers — same all-rows view via the CORE-5237 lumping
 *     rule below. The location cert-requirements picker UX historically
 *     called this endpoint; on v4 it moves to the dedicated nested
 *     resource ``/api/locations/{location_id}/available-certifications/``
 *     (``LocationAvailableCertificationsView``), and the v4 permission
 *     cleanup that removes LM access from this catalog will land then.
 *   - pros (read-only browse) — see active-only rows via the default
 *     ``Certification.objects`` manager. The Pro market-aware catalog cut
 *     lives on a dedicated endpoint
 *     ``/api/gigster-profiles/{pk}/available-certifications/``
 *     (``ProAvailableCertificationsView``); this catalog endpoint stays
 *     unfiltered to preserve the byte-identical default contract for
 *     existing clients.
 */
export const certificationsCreate = async (certificationRequest: CertificationRequest, options?: Parameters<typeof customFetch>[1]): Promise<Certification> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Certification>(getCertificationsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(certificationRequest)
  }
);}





export const getCertificationsCreateMutationKey = () => ['certificationsCreate'] as const;

export const getCertificationsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof certificationsCreate>>, TError,CertificationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof certificationsCreate>>, TError,CertificationsCreateMutationVariables, TContext> => {

const mutationKey = getCertificationsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof certificationsCreate>>, CertificationsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  certificationsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CertificationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof certificationsCreate>>>
    export type CertificationsCreateMutationBody = CertificationRequest
    export type CertificationsCreateMutationError = void
    export type CertificationsCreateMutationVariables = {data: CertificationRequest}

    export const useCertificationsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof certificationsCreate>>, TError,CertificationsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof certificationsCreate>>,
        TError,
        CertificationsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCertificationsCreateMutationOptions(options), queryClient);
    }
    export const getCertificationsRetrieveUrl = (id: number,) => {




  return `/api/certifications/${id}/`
}

/**
 * Global Certification catalog.
 *
 * Three callers share this endpoint:
 *
 *   - ``is_gigpro_admin`` (taxonomy management) — sees every row including
 *     ``is_active=False`` so admin tools can toggle status.
 *   - location managers — same all-rows view via the CORE-5237 lumping
 *     rule below. The location cert-requirements picker UX historically
 *     called this endpoint; on v4 it moves to the dedicated nested
 *     resource ``/api/locations/{location_id}/available-certifications/``
 *     (``LocationAvailableCertificationsView``), and the v4 permission
 *     cleanup that removes LM access from this catalog will land then.
 *   - pros (read-only browse) — see active-only rows via the default
 *     ``Certification.objects`` manager. The Pro market-aware catalog cut
 *     lives on a dedicated endpoint
 *     ``/api/gigster-profiles/{pk}/available-certifications/``
 *     (``ProAvailableCertificationsView``); this catalog endpoint stays
 *     unfiltered to preserve the byte-identical default contract for
 *     existing clients.
 */
export const certificationsRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<Certification> => {

  return customFetch<Certification>(getCertificationsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCertificationsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/certifications/${id}/`
    ] as const;
    }


export const getCertificationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof certificationsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCertificationsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof certificationsRetrieve>>> = ({ signal }) => certificationsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof certificationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CertificationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof certificationsRetrieve>>>
export type CertificationsRetrieveQueryError = void


export function useCertificationsRetrieve<TData = Awaited<ReturnType<typeof certificationsRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof certificationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof certificationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCertificationsRetrieve<TData = Awaited<ReturnType<typeof certificationsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof certificationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof certificationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCertificationsRetrieve<TData = Awaited<ReturnType<typeof certificationsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCertificationsRetrieve<TData = Awaited<ReturnType<typeof certificationsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof certificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCertificationsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCertificationsPartialUpdateUrl = (id: number,) => {




  return `/api/certifications/${id}/`
}

/**
 * Global Certification catalog.
 *
 * Three callers share this endpoint:
 *
 *   - ``is_gigpro_admin`` (taxonomy management) — sees every row including
 *     ``is_active=False`` so admin tools can toggle status.
 *   - location managers — same all-rows view via the CORE-5237 lumping
 *     rule below. The location cert-requirements picker UX historically
 *     called this endpoint; on v4 it moves to the dedicated nested
 *     resource ``/api/locations/{location_id}/available-certifications/``
 *     (``LocationAvailableCertificationsView``), and the v4 permission
 *     cleanup that removes LM access from this catalog will land then.
 *   - pros (read-only browse) — see active-only rows via the default
 *     ``Certification.objects`` manager. The Pro market-aware catalog cut
 *     lives on a dedicated endpoint
 *     ``/api/gigster-profiles/{pk}/available-certifications/``
 *     (``ProAvailableCertificationsView``); this catalog endpoint stays
 *     unfiltered to preserve the byte-identical default contract for
 *     existing clients.
 */
export const certificationsPartialUpdate = async (id: number,
    patchedCertificationRequest?: PatchedCertificationRequest, options?: Parameters<typeof customFetch>[1]): Promise<Certification> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<Certification>(getCertificationsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedCertificationRequest)
  }
);}





export const getCertificationsPartialUpdateMutationKey = () => ['certificationsPartialUpdate'] as const;

export const getCertificationsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof certificationsPartialUpdate>>, TError,CertificationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof certificationsPartialUpdate>>, TError,CertificationsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getCertificationsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof certificationsPartialUpdate>>, CertificationsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  certificationsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CertificationsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof certificationsPartialUpdate>>>
    export type CertificationsPartialUpdateMutationBody = PatchedCertificationRequest | undefined
    export type CertificationsPartialUpdateMutationError = void
    export type CertificationsPartialUpdateMutationVariables = {id: number;data?: PatchedCertificationRequest}

    export const useCertificationsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof certificationsPartialUpdate>>, TError,CertificationsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof certificationsPartialUpdate>>,
        TError,
        CertificationsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getCertificationsPartialUpdateMutationOptions(options), queryClient);
    }
